import { Accordion, AccordionHeader } from "@aircall/tractor";
import styled, { getSpace } from "@xstyled/styled-components";

export const PlaygroundAccordion = styled(Accordion)`
  gap: ${getSpace("m")};
`;

export const PlaygroundAccordionHeader = styled(AccordionHeader)`
  z-index: initial;
  cursor: pointer;
`;
